import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { setPropertyValue } from "./../../../ducks/fundingArea";
import {
  changeProperty,
  closeModalDialog,
  filterSelected,
  filterSelectedArea,
  INDICATOR_FUNDING_AREA,
  INDICATOR_ID,
  INDICATOR_IDENTIFIER,
  INDICATOR_LIST,
  INDICATOR_LONG,
  INDICATOR_NAME,
  INDICATOR_PROGRAM,
  INDICATOR_SHORT,
  INDICATOR_SHORT_NAME,
  IS_NEW,
  LOADED,
  loadIndicator,
  loadIndicatorListFilter,
  newIndicator,
  saveIndicator,
  SHOW_MODAL,
  SORT_TABLE_INDICATOR,
  SORT_TABLE_INDICATOR_BY,
  submitModalDialog
} from "../../../ducks/indicatorAdmin";

import IndicatorAdmin from "./IndicatorAdmin";

const mapStateToProps = (state) => {
  return {
    indicatorName: state.indicatorList[INDICATOR_NAME],
    indicatorId: state.indicatorList[INDICATOR_ID],
    indicatorList: state.indicatorList[INDICATOR_LIST],
    showModal: state.indicatorList[SHOW_MODAL],
    fundingArea: state.indicatorList[INDICATOR_FUNDING_AREA],
    isNew: state.indicatorList[IS_NEW],
    indicatorShort: state.indicatorList[INDICATOR_SHORT_NAME],
    program: state.indicatorList[INDICATOR_PROGRAM],
    identifier: state.indicatorList[INDICATOR_IDENTIFIER],
    sortTableTemplate: state.indicatorList[SORT_TABLE_INDICATOR],
    sortTableIndicatorBy: state.indicatorList[SORT_TABLE_INDICATOR_BY],
    shortName: state.indicatorList[INDICATOR_SHORT],
    longName: state.indicatorList[INDICATOR_LONG],
    [LOADED]: state.indicatorList[LOADED]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setPropertyValue,
      loadIndicator,
      filterSelectedArea,
      filterSelected,
      newIndicator,
      closeModalDialog,
      saveIndicator,
      submitModalDialog,
      changeProperty,
      loadIndicatorListFilter
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorAdmin);
